import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import Colors from '../../../../shared/assets/style/default/color';

const AccessActionsContainer = styled.div<React.CSSProperties>`
  position: absolute;
  right: 0;
  width: ${663 * Screen.widthRatio}px;
  height: 100%;
  background: ${Colors.background};
`;

export default AccessActionsContainer;
